export default "__VITE_ASSET__2bf771c7__"